<!--suppress TypeScriptUnresolvedVariable -->
<!--<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>-->

<!--<div #signatureContainer class="signature-container">-->
<!--    <ngx-signaturepad #signaturePad [options]="options" [width]="width" [height]="height"></ngx-signaturepad>-->
    <signature-pad #signaturePad [options]="options"></signature-pad>
<!--</div>-->
